import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=2fedb088&scoped=true"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"
import style0 from "./TicketsList.vue?vue&type=style&index=0&id=2fedb088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedb088",
  null
  
)

export default component.exports